<template>
    <b-modal
        id="modal-create-edit"
        class="modal-demo"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        size="lg"
        centered
        hide-footer
        @hidden="hideModal"
    >
        <template slot="modal-title">
            {{ modalTitle }}
        </template>

        <div class="custom-modal-text text-left">
            <upload v-if="!editMode" @uploaded="onMediaUploaded" />
            <media-details
                v-else
                :media="mediaToEdit"
                preview
                @cancel="hideModal"
                @updated="onMediaUpdate"
            />
        </div>
    </b-modal>
</template>

<script>
import MediaDetails from './Details';
import Upload from './Upload';

export default {
    components: {
        MediaDetails,
        Upload
    },

    props: {
        mediaToEdit: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    computed: {
        editMode() {
            return !!this.mediaToEdit && !!this.mediaToEdit.id;
        },

        uploadedBy() {
            const { user } = this.mediaToEdit;

            return user ? user.fullName : 'System';
        },

        modalTitle() {
            return this.editMode
                ? `Edit ${this.mediaToEdit.name} | Uploaded by: ${this.uploadedBy}`
                : `Add new media`;
        }
    },

    methods: {
        onMediaUploaded() {
            this.$toaster('Files has been uploaded.');

            this.$emit('fetch-media');
            this.hideModal();
        },

        onMediaUpdate(media) {
            this.$emit('updated', media);
        },

        hideModal() {
            this.$bvModal.hide('modal-create-edit');
            this.$emit('hide');
        }
    }
};
</script>
